<template>
  <v-main class="green lighten-4">
    <v-container fluid fill-height>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="10" md="8" lg="6">
          <v-card class="elevation-12">
            <v-toolbar color="green darken-2" dark flat>找回密码</v-toolbar>
            <v-card-text>
              <v-form ref="form">
                <v-text-field
                  ref="email"
                  label="Email"
                  prepend-icon="mdi-email"
                  clearable
                  validate-on-blur
                  v-model="email"
                  :rules="rules.email"
                  required
                ></v-text-field>
                <v-text-field
                  label="验证码"
                  prepend-icon="mdi-puzzle"
                  clearable
                  v-model="captch"
                  :rules="[v=>!!v||'必填项']"
                  required
                >
                  <template v-slot:append-outer>
                    <v-btn
                      :disabled="regetcaptchtime>0"
                      color="primary"
                      :loading="loading"
                      @click="getCaptchaForEmail"
                    >获取验证码{{regetcaptchtime>0?regetcaptchtime:''}}</v-btn>
                  </template>
                </v-text-field>
                <v-text-field
                  label="密码"
                  prepend-icon="mdi-lock"
                  :type="showpassword?'text':'password'"
                  :append-icon="showpassword?'mdi-eye-off':'mdi-eye'"
                  @click:append="showpassword = !showpassword"
                  clearable
                  v-model="password"
                  :rules="rules.password"
                  validate-on-blur
                ></v-text-field>
                <v-text-field
                  v-show="!!password"
                  label="确认密码"
                  prepend-icon="mdi-lock"
                  :type="showpassword?'text':'password'"
                  :append-icon="showpassword?'mdi-eye-off':'mdi-eye'"
                  @click:append="showpassword = !showpassword"
                  clearable
                  v-model="configpass"
                  :rules="rules.configpassword"
                  validate-on-blur
                ></v-text-field>
                <v-card-actions>
                  <v-btn dark color="orange darken-2" @click="$router.go(-1)">返回</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn :loading="loading" color="success" @click="submit">提交</v-btn>
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  data: function () {
    return {
      password: null,
      configpass: null,
      loading: false,
      showpassword: false,
      regetcaptchtime: 0,
      timer: null,
      email: null,
      captch: null,
      rules: {
        password: [
          (value) => !!value || "必填项",
          (value) =>
            value === null ||
            (value.length >= 6 && value.length <= 20) ||
            "长度6-20",
        ],
        configpassword: [
          (value) =>
            value == this.password ||
            (this.password === null && value === "") ||
            (value === null && this.password === "") ||
            "密码不一致",
        ],
        email: [
          (value) => !!value || "必填项",
          (value) =>
            value === null ||
            (value.length >= 6 && value.length <= 40) ||
            "长度6-40",
          (value) =>
            value === null ||
            /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
              value
            ) ||
            "Email格式不正确",
        ],
      },
    };
  },
  watch: {
    regetcaptchtime() {
      if (this.regetcaptchtime <= 0) {
        clearInterval(this.timer);
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$api
          .reSetPasswordForEmail({
            Email: this.email,
            Password: this.password,
            Captcha: this.captch,
          })
          .then((res) => {
            this.loading = false;
            this.$store.commit("setsnack", {message: "密码修改成功，请重新登录!",color: "success"});
            this.$router.push('/login')
          })
          .catch((error) => {
            this.loading = false;
            console.error(error);
            this.$store.commit("setsnack", { message: "密码修改失败!" });
          });
      }
    },
    getCaptchaForEmail() {
      if (this.$refs.email.validate()) {
        this.loading = true;
        this.$api
          .getCaptchaForEmail({
            Email: this.email,
          })
          .then((res) => {
            this.loading = false;
            this.regetcaptchtime = 600;
            this.timer = setInterval(() => {
              this.regetcaptchtime--;
            }, 1000);
            this.$store.commit("setsnack", {
              message: "验证码邮件发送成功，请收取，有效时间10分钟!",
              color: "primary",
              timeout: 0,
            });
          })
          .catch((error) => {
            this.loading = false;
            if (error.msg == "<QuerySeter> no row found") {
              this.$store.commit("setsnack", {
                message: "该邮箱不存在，请检查输入是否有误!",
              });
            } else {
              console.error(error);
            }
          });
      } else {
        this.$store.commit("setsnack", { message: "请检查Email输入!" });
      }
    },
  },
};
</script>